import React from 'react'
import { useSmartviewMounter } from '@morningtrain/react-smartviews'
import { ModelContext, useModel, useValue } from '@morningtrain/react-resources'
import useGlobalActiveState from 'support/hooks/use-global-active-state'

export default function MountSmartviewOnClickTableRow ({
  model = null,
  smartview = null,
  replace = false,
  activeGroup = 'table_row',
  children
}) {
  const parentModel = useModel()
  const key = useValue('id')

  const currentModel = model || parentModel

  const [isActive, setIsActive] = useGlobalActiveState(activeGroup, key)

  const wrappedSmartview = (
    <ModelContext.Provider value={currentModel}>
      {smartview}
    </ModelContext.Provider>
  )

  const mount = useSmartviewMounter(wrappedSmartview, replace)

  const handleOnClick = (e) => {
    setIsActive(true)
    mount()
  }

  const classNames = [
    'cursor-pointer',
    isActive ? 'active-table-row' : null
  ].filter(c => c).join(' ')

  return (
    <tr onClick={handleOnClick} className={classNames}>
      {children}
    </tr>
  )
}
